import { createIcon } from './create-icon';
import React from 'react';
import './icon-eye.scss';

export const IconEye = createIcon(<div className="icon-eye" />);
